import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { RECOMMENDATIONS_API } from '../../constants/central-api';

export default async function get_automated_recommendation_settings_api_call(
  recommendationId: string
) {
  const accessToken = store.getState().user?.stats?.ai_tracker_access_token;

  if (!accessToken) {
    return false;
  }

  const requestInfo: RequestInfo = {
    url: `${RECOMMENDATIONS_API}/${recommendationId}/settings`,
    method: 'GET',
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  };

  const actionType = 'GET_AUTOMATED_RECOMMENDATION_SETTINGS';
  const customMsg = 'Recommendation settings loaded successfully';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false,
    true,
    false,
    true
  );

  const response = res?.data;
  if (!response?.success) {
    return false;
  }
  if (res?.actionType === actionType && response?.success === true) {
    return response?.data || null;
  }
}
